import Branding from "@/components/features/Landing/Branding";
import styled from "styled-components";
import LandingFooter from "@/components/features/Landing/LandingFooter";

const MobileLandingPage = () => {
  return (
    <Layout>
      <Container>
        <ImgWrapper>
          <SatelliteImg src="static/sat-img.png" alt="satellite" />
        </ImgWrapper>
        <Branding />
      </Container>
      <H2>We track & simulate OOSI events</H2>
      <FooterWrapper>
        <LandingFooter />
      </FooterWrapper>
    </Layout>
  );
};

export default MobileLandingPage;

const Layout = styled.div`
  width: 100%;
  /* height: calc(100vh - 12rem - 2px); */
  box-sizing: border-box;
  padding: 2rem;

  display: flex;
  flex-direction: column;
  gap: 3rem;
  justify-content: space-between;
`;

const ImgWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SatelliteImg = styled.img`
  width: 100%;
  padding-top: 5rem;
  transform: scaleX(-1) rotate(-20deg);
`;

const H2 = styled.h2`
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.3;
  padding: 0 2rem 2rem 2rem;
  @media screen and (max-width: 400px) {
    font-size: 1.5rem;
  }
`;

const Container = styled.main`
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const FooterWrapper = styled.footer``;
